<template>
  <div class="website-end">
    <p>{{ $t("互联网宗教信息服务许可证：浙（2025）0000313  版权声明： 2025-2028 极乐寺 ") }}</p>
    <p>{{ $t("（国家宗教事务局监制）") }}</p>
 </div>
</template>

<script>
export default {
  name: 'WebsiteEnd',
  components:{
  },
  data() { 
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  computed:{
  },
  watch:{
  },
  methods:{

  },
 }
</script>

<style lang='scss' scoped>
.website-end {
height: 300px;
width: 100%;
background-image: url('@/assets/img/function/endbj.png');
background-size: cover;
background-repeat: no-repeat;
text-align: center;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
position: relative;
}
@media screen and (max-width: 768px) {
.website-end {
  height: 150px;
  // position: fixed;
  // bottom: 0;
}
}
</style>